// src/theme/tokens/motion.js
// Source of truth for Figma motion tokens

export const motion = {
  // Duration (milliseconds)
  durationFast: 100,  // duration-fast
  durationMid: 200,   // duration-normal
  durationSlow: 400,  // duration-slow

  // Easing
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)', // easing-standard
  easeOut: 'cubic-bezier(0, 0, 0.2, 1)',    // easing-decelerate
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',     // easing-accelerate
};

